import { useEffect, useMemo, useState } from 'react';
import type { Socket } from 'socket.io-client';
import { SocketNamespace } from '@trinity/chat';
import { createLogger } from '../utils';
import { useGetSocket } from './useGetSocket';
import { useSetupDefaultSocketListeners } from './useSetupDefaultListeners';

export const useFileSocket = (): Socket => {
  const [socket, setSocket] = useState<Socket>();
  const getSocket = useGetSocket(SocketNamespace.Files);

  const logger = useMemo(() => createLogger({
    namespace: SocketNamespace.Files,
  }), []);

  useEffect(() => {
    logger.log('Setting up file socket');
    const newSocket = getSocket();

    setSocket(newSocket);

    return () => {
      logger.log('Cleaning up file socket');
      newSocket.disconnect();
    };
  }, [getSocket, logger]);

  useSetupDefaultSocketListeners(socket, SocketNamespace.Files);

  return socket;
};